import { FeedbackActionEnum } from '@daymade/api-contracts';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import HttpStatusCode from 'utils/HttpStatusCode';
import { feedbackApiClient } from 'utils/apiClient';
import GraphicWrapper from '../GraphicWrapper';
import RetroIconSVG from '../RetroIconSVG';
import GenericButton from '../generic-button/GenericButton';
import styles from './SuggestionBox.module.css';

const SuggestionBoxSection = observer(() => {
  const [comment, setComment] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const trimmedComment = comment?.trim();

  const submitFeedback = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    if (success) {
      return;
    }

    if (trimmedComment) {
      setLoading(true);

      const resp = await feedbackApiClient.public.sendFeedback({
        body: {
          action: FeedbackActionEnum.TOKEN_TOWN,
          feedback: {
            [FeedbackActionEnum.TOKEN_TOWN]: {
              comment: trimmedComment,
            },
          },
        },
      });

      if (resp.status === HttpStatusCode.OK) {
        setSuccess(true);
        setLoading(false);
      }
    }
  };

  return (
    <GraphicWrapper imagePosition="bottom" imageOverlay={true}>
      <div className={`${styles.suggestionBox} fullWidth`}>
        <div className={styles.header}>
          <RetroIconSVG fname="suggestion-box" className={styles.commentIcon} />
          <h2 className={styles.title}>Suggestion box</h2>
          <p className={styles.description}>
            Are there any other causes you’d like to support? Let us know right
            here!
          </p>
        </div>

        <div className={styles.form}>
          <form>
            <label className={styles.visuallyHidden}>Suggestions box:</label>
            <textarea
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
                if (success) {
                  setSuccess(false);
                }
              }}
              className={styles.textArea}
              placeholder="Write your suggestion..."
            />

            <GenericButton
              onClick={(e) => {
                submitFeedback(e);
              }}
              loading={loading}
              disabled={loading || success || !trimmedComment}
            >
              {success ? 'SUBMITTED!' : 'SUBMIT'}
            </GenericButton>
          </form>
        </div>
      </div>
    </GraphicWrapper>
  );
});

export default SuggestionBoxSection;
